import { cx } from "./cx";
import type { IconSize } from "./icon";

export interface SpinnerProps {
  size?: IconSize;
  tone?: "accent" | "muted" | "inverse";
  /** Accessible label announced to screen readers. */
  label?: string;
  className?: string;
}

/** Inline loading indicator — icon-token sizes, motion-token duration. */
export function Spinner({ size = "md", tone = "accent", label = "Loading", className }: SpinnerProps) {
  return (
    <svg
      className={cx(
        "pz-spinner",
        `pz-icon--${size}`,
        tone === "muted" && "pz-spinner--muted",
        tone === "inverse" && "pz-spinner--inverse",
        className,
      )}
      viewBox="0 0 24 24"
      fill="none"
      role="status"
      aria-label={label}
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeOpacity="0.25" strokeWidth="2.5" />
      <path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
  );
}
